export const SetImg = (data) => {
  let img = data._embedded['wp:featuredmedia'];
  let imgDefault = `${tmp_path.temp_uri}/dist/assets/images/common/noimage.webp`;
  return img ? img[0].source_url : imgDefault;
}
